import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/mangaList";

const heroStats = [
  { value: "1200+", label: "收录作品" },
  { value: "8万+", label: "总章节数" },
  { value: "300+", label: "每日更新" },
  { value: "500万+", label: "在线读者" },
];

export default function HeroSection() {
  const featured = mangaList.find((m) => m.isFeatured) ?? mangaList[0];

  return (
    <section className="relative flex h-[420px] items-center justify-center overflow-hidden md:h-[600px]" aria-label="网站介绍">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20anime%20key%20visual%20of%20a%20determined%20teenage%20boy%20with%20spiky%20dark%20hair%20standing%20amid%20roaring%20orange%20flames%2C%20a%20tiny%20baby%20hitman%20in%20a%20black%20suit%20on%20his%20shoulder%2C%20dramatic%20cinematic%20manga%20poster%20art%2C%20dark%20charcoal%20background%20filled%20with%20floating%20embers%20and%20sparks%2C%20intense%20warm%20orange%20rim%20lighting%2C%20high%20contrast%2C%20premium%20shonen%20manga%20promotional%20art&width=1600&height=900&seq=manga-hero-001&orientation=landscape"
        alt="《家庭教师》漫画热血火焰主题背景"
        title="家庭教师漫画免费阅读"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" aria-hidden="true" />

      <div className="relative z-10 w-full px-4 text-center md:px-6">
        <p className="animate-fade-up mb-4 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm md:text-sm">
          <i className="ri-flashlight-fill text-secondary-300" aria-hidden="true" />
          本站主打:《家庭教师》漫画全集免费阅读
        </p>
        <h1 className="animate-fade-up delay-100 mx-auto max-w-4xl font-heading text-3xl font-bold leading-snug text-background-50 md:text-5xl">
          家庭教师漫画全集免费阅读
        </h1>
        <p className="animate-fade-up delay-200 mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base">
          从「废柴阿纲」到彭格列第十代首领,一段燃烧火焰的热血成长物语。406 话完整收录,高清画质,每日更新,随点随读。
        </p>
        <div className="animate-fade-up delay-300 mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to={`/article/${featured.latestChapterId}`}
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            title="立即开始阅读家庭教师漫画"
          >
            <i className="ri-book-open-line" aria-hidden="true" />
            立即开始阅读
          </Link>
          <Link
            to="/category"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            <i className="ri-grid-fill" aria-hidden="true" />
            浏览全部漫画
          </Link>
        </div>

        <div className="animate-fade-up delay-300 mx-auto mt-10 grid w-full max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="rounded-lg bg-background-50/10 px-3 py-3 backdrop-blur-sm">
              <p className="font-heading text-lg font-bold text-background-50 md:text-xl">{stat.value}</p>
              <p className="mt-0.5 text-xs text-background-50/70">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}